import React from 'react';
import SearchParams from '../Elements/SearchParams';
import FreelancerInvoicesSearchParams from '../Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoicesSearchParams';
import FreelancerInvoiceItem from '../Domain/FreelancerInvoiceItem';
import AuthService from './authService.js';

class FreelancerInvoiceService extends React.Component {
  static GetInvoiceList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    if (searchItem) {
      searchItem.Yrmo = searchItem.Yrmo.toString();
      searchItem.FreelancerInvoiceId = searchItem.FreelancerInvoiceId.toString();
      searchItem.FreelancerPaymentExportId = searchItem.FreelancerPaymentExportId.toString();
    }
    const searchParams = new SearchParams(searchItem, FreelancerInvoicesSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/FreelancerInvoice/GetFreelancerInvoiceList?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static DownloadInvoiceListDetailsInExcel(invoiceId) {
    const url = `/api/FreelancerInvoice/DownloadInExcel/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async FinalizeSelectedFreelancerInvoices(allItemInTheSearchSetAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchSetAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/FinalizeSelectedFreelancerInvoices';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async SetToPaidSelectedFreelancerInvoices(allItemInTheSearchSetAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchSetAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/SetToPaidSelectedFreelancerInvoices';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async SetToManuallyPaidSelectedFreelancerInvoices(allItemInTheSearchSetAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchSetAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/SetToManuallyPaidSelectedFreelancerInvoices/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async ExportSelectedFreelancerInvoicesToExcel(allItemInTheSearchAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/ExportSelectedFreelancerInvoicesToExcel/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async ExportSelectedFreelancerInvoiceAttachmentsToZip(allItemInTheSearchAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/ExportSelectedFreelancerInvoiceAttachmentsToZip/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async SendSelectedFreelancerInvoicesToTheVendor(allItemInTheSearchAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/SendSelectedFreelancerInvoicesToTheVendor/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async SendSelectedFreelancerInvoicesToTheVendorForFinalization(
    allItemInTheSearchAreSelected,
    selectedIds,
    searchItem
  ) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/SendSelectedFreelancerInvoicesToTheVendorForFinalization/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async ExportSelectedFreelancerInvoicesAsPayment(allItemInTheSearchSetAreSelected, selectedIds, searchItem) {
    const params = {
      AllItemInTheSearchAreSelected: allItemInTheSearchSetAreSelected,
      SelectedIds: selectedIds,
      SearchItem: searchItem,
    };
    const url = 'api/FreelancerInvoice/ExportSelectedFreelancerInvoicesAsPayment/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(params));
  }

  static async CreateFreelancerInvoice(freelancerUserId) {
    const url = `api/FreelancerInvoice/CreateFreelancerInvoice/${freelancerUserId}`;
    return AuthService.getInstance().CallBackendFunctionPut(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerInvoiceItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static postUploadInvoiceImageFile(data) {
    const authService = AuthService.getInstance();

    const url = '/api/FreelancerInvoice/PostInvoiceImageFile';

    return authService.CallBackendFunctionPostFile(url, data);
  }

  static GetInvoiceImageFile(invoiceId) {
    const url = `/api/FreelancerInvoice/GetFreelancerInvoiceImage/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunctionGetFile(url);
  }

  static GetFreelancerInvoiceById(invoiceId) {
    const url = `/api/FreelancerInvoice/GetFreelancerInvoiceById/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  // static GetInvoiceImageUrl(invoiceId) {
  //   const url = `api/FreelancerInvoice/GetFreelancerInvoiceImage/${invoiceId}`;

  //   return AuthService.getInstance().GetApiUrl() + url;
  // }

  static ApproveInvoiceImageFile(invoiceId) {
    const url = `/api/FreelancerInvoice/ApproveFreelancerInvoiceImage/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunctionPut(url);
  }

  static DismissInvoiceImageFile(invoiceId) {
    const url = `/api/FreelancerInvoice/DismissFreelancerInvoiceImage/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunctionPut(url);
  }

  static DeleteInvoiceById(invoiceId) {
    const url = `/api/FreelancerInvoice/DeleteFreelancerInvoiceById/${invoiceId}`;

    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }
}

export default FreelancerInvoiceService;
